export default __webpack_public_path__ + "static/media/gulvinder.9e874452.jpg";